<div class="alerts-dropdown-container">
  <!-- Warning Icon with Badge -->
  <div class="alerts-trigger" (click)="onToggleDropdown($event)">
    <div class="warning-icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="currentColor"/>
      </svg>
      <!-- Badge for unread count -->
      <div class="alerts-badge" *ngIf="unreadCount > 0">
        <span>{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
      </div>
    </div>
  </div>

  <!-- Dropdown Panel -->
  <div class="alerts-dropdown" [class.open]="isOpen">
    <div class="dropdown-header">
      <h4>Alerts</h4>
      <button class="close-btn" (click)="onToggleDropdown($event)">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
        </svg>
      </button>
    </div>

    <div class="dropdown-content">
      <!-- Alerts List -->
      <div class="alerts-list" *ngIf="alerts.length > 0">
        <div class="alert-item" *ngFor="let alert of alerts">
          <div class="alert-content">
            <div class="alert-title">{{ alert.product_name }}</div>
            <div class="alert-cabinet" *ngIf="alert.cabinet_name">{{ alert.cabinet_name }}</div>
            <div class="alert-status-action">
              <div class="status-section">
                <div class="status-badge" [class]="alert.status">
                  <img *ngIf="alert.status === 'low stock'" src="../../../../assets/images/storelist/lowstock.svg" alt="Low Stock">
                  <img *ngIf="alert.status === 'missing'" src="../../../../assets/images/storelist/missing.svg" alt="Missing">
                  {{ alert.status }}
                </div>
                <div class="alert-count">{{ alert.count }}</div>
              </div>
              <button class="mark-closed-btn" (click)="openDialog(alert)">
                <img src="../../../../assets/images/storelist/tickmark.svg" alt="Mark Closed">
                <span>Mark Closed</span>
              </button>
            </div>
            <div class="alert-meta">
              <span class="store-name">{{ alert.store_name }}</span>
              <span class="date">{{ timestampFormat(alert.raised_at, "DD/MM/YYYY") }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div class="empty-state" *ngIf="alerts.length === 0">
        <div class="empty-icon">⚠️</div>
        <p>No active alerts</p>
      </div>

      <!-- View All Link -->
      <div class="view-all-section" *ngIf="alerts.length > 0">
        <a class="view-all-link" (click)="navigateToAlertList($event)">View All Alerts</a>
      </div>
    </div>
  </div>
</div> 